import React, { useContext } from "react";
import HeaderInner from "../../Components/HeaderInner";
import Clientinfo from "../../Components/Clientinfo";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import NewFooter from "../../NewFooter";
import Title from "../../new-components/title/Title";
import { ThemeContext } from "../../context/ThemeContext";
import Textheader from "../../Components/Textheader";

function LateCheckoutOrderPlaced() {
  const location = useLocation();

  const rawPath = location.pathname;
  const room_uuid = rawPath.split("/")[1];

  const data = location.state?.metadata;

  const { t } = useTranslation();
  const { theme } = useContext(ThemeContext);

  const currency = localStorage.getItem("currency");

  // Because sometimes we pass:
  // metadata: { res: res.data.data }
  // and sometimes metadata: res.data.data
  const orderData = data?.res || data;

  const lateCheckoutOrder = orderData?.late_checkout_order;

  return (
    <div className={theme ? "food" : ""}>
      {theme ? (
        <Title title={t("Order Details")} />
      ) : (
        <HeaderInner headerName={t("Order Details")} />
      )}

      <main className="home-main pad-top-0 back-fe">
        <Textheader />
        <Clientinfo
          roomNumber={orderData?.room_name}
          orderNumber={orderData?.order_number}
          orderedAt={orderData?.ordered_at}
        />

        <div className="full-heading grey-bg flex">
          <h2 className="blck co-header">{t("Order Details")}</h2>
        </div>

        <div className="full-div padd-div">
          <div className="booking-order-detail">
            <div className="txt-pnl">
              <p>{orderData?.title || t("Late Checkout")}</p>
              <h3>
                 {currency}{" "}{lateCheckoutOrder?.price || orderData?.total}
              </h3>
            </div>
          </div>
        </div>

        <div className="spacer-20" />

        <div className="full-div padd-div text-center">
          <Link className="reg-btn big" to={`/${room_uuid}/qr-code`}>
            {t("Back to Home")}
          </Link>
        </div>
      </main>

      {theme && <NewFooter />}
    </div>
  );
}

export default LateCheckoutOrderPlaced;
